import { useQuery } from "@tanstack/react-query";
import { GET_MASTER_TABLE_COLUMN_QUERY_KEY } from "../types/CommonTypes";
import { fetcher } from "../../../utils/Axios";
import { GET_MASTER_TABLE_COLUMN_RESPONSE } from "../types/ResponseTypes";

async function getMasterTableColumn(): Promise<GET_MASTER_TABLE_COLUMN_RESPONSE> {
  const { data } = await fetcher({
    url: "analytics/master-data/columns",
  });
  return data;
}

const useGetMasterTableColumnQuery = () => {
  return useQuery({
    queryKey: [GET_MASTER_TABLE_COLUMN_QUERY_KEY],
    queryFn: getMasterTableColumn,
  });
};

export default useGetMasterTableColumnQuery;
